import { IOrderDetails } from "interfaces/IOrder";
import { useMemo } from "react";
import { Col, Form, Row } from "react-bootstrap";

/**
 * Custom props for the upper section of the details
 */
interface Props {
    /**
     * The order details state
     */
    order: IOrderDetails;
}

/**
 * interface that models the address information
 */
interface IOrderAddress {
    /**
     * The street of the address
     */
    street: string;
    /**
     * The number of the address
     */
    number: string;
    /**
     * The colonia of the address
     */
    colonia: string;
    /**
     * The zipCode of the address
     */
    zipCode: string;
    /**
     * The state of the address
     */
    state: string;
    /**
     * The city of the address
     */
    city: string;
    /**
     * The references of the address
     */
    references: string;
}

/**
 * This is the main content section for the order details component
*/
export const ContentSection = ({ order }: Props) => {
    /**
     * This use memo is used to fetch the order data properly
     * to be put on the rest of the form controls
     */
    const orderAddress = useMemo(() => {
        const addressArray = order.shipping_address.split(",");
        const orderInfo: IOrderAddress = {
            street: addressArray[0] ?? "",
            number: addressArray[1] ?? "",
            colonia: addressArray[2] ?? "",
            zipCode: addressArray[3] ?? "",
            state: addressArray[4] ?? "",
            city: addressArray[5] ?? "",
            references: addressArray[7] ?? ""
        };
        return orderInfo;
    },[order]);

    return (
        <Form className="mb-3">
            <Col xs={12}>
                <Col xs={12} className="mb-1">
                    <Form.Label>
                        <strong>Nombre de cliente:</strong>
                    </Form.Label>
                    <Form.Control
                        type="text"
                        onChange={() => { }}
                        value={order.user_name}
                        readOnly={true}
                        placeholder={order.user_name}
                    />
                </Col>
                <Row className="mb-1">
                    <Col xs={6}>
                        <Form.Label>
                            <strong>Correo electrónico:</strong>
                        </Form.Label>
                        <Form.Control
                            type="text"
                            onChange={() => { }}
                            value={order.user_email}
                            readOnly={true}
                            placeholder={order.user_email}
                        />
                    </Col>
                    <Col xs={6} >
                        <Form.Label>
                            <strong>Teléfono:</strong>
                        </Form.Label>
                        <Form.Control
                            type="text"
                            onChange={() => { }}
                            value={order.user_phone}
                            readOnly={true}
                            placeholder={order.user_phone}
                        />
                    </Col>
                </Row>
                <Row className="mb-1">
                    <Col xs={6} >
                        <Form.Label>
                            <strong>Dirección:</strong>
                        </Form.Label>
                        <Form.Control
                            type="text"
                            onChange={() => { }}
                            value={orderAddress.street}
                            readOnly={true}
                            placeholder={orderAddress.street}
                        />
                    </Col>
                    <Col xs={6} >
                        <Form.Label>
                            <strong>Número:</strong>
                        </Form.Label>
                        <Form.Control
                            type="text"
                            onChange={() => { }}
                            value={orderAddress.number}
                            readOnly={true}
                            placeholder={orderAddress.number}
                        />
                    </Col>
                </Row>
                <Row className="mb-1">
                    <Col xs={6} >
                        <Form.Label>
                            <strong>Colonia:</strong>
                        </Form.Label>
                        <Form.Control
                            type="text"
                            onChange={() => { }}
                            value={orderAddress.colonia}
                            readOnly={true}
                            placeholder={orderAddress.colonia}
                        />
                    </Col>
                    <Col xs={6} >
                        <Form.Label>
                            <strong>Código postal:</strong>
                        </Form.Label>
                        <Form.Control
                            type="text"
                            onChange={() => { }}
                            value={orderAddress.zipCode}
                            readOnly={true}
                            placeholder={orderAddress.zipCode}
                        />
                    </Col>
                </Row>
                <Row className="mb-1">
                    <Col xs={6} >
                        <Form.Label>
                            <strong>Estado:</strong>
                        </Form.Label>
                        <Form.Control
                            type="text"
                            onChange={() => { }}
                            value={orderAddress.state}
                            readOnly={true}
                            placeholder={orderAddress.state}
                        />
                    </Col>
                    <Col xs={6} >
                        <Form.Label>
                            <strong>Ciudad:</strong>
                        </Form.Label>
                        <Form.Control
                            type="text"
                            onChange={() => { }}
                            value={orderAddress.city}
                            readOnly={true}
                            placeholder={orderAddress.city}
                        />
                    </Col>
                </Row>
                <Row className="mb-1">
                    <Col xs={6} >
                        <Form.Label>
                            <strong>Referencias:</strong>
                        </Form.Label>
                        <Form.Control
                            style={{  resize: "none" }}
                            rows={5}
                            type="text"
                            as={"textarea"}
                            onChange={() => { }}
                            value={orderAddress.state}
                            readOnly={true}
                            placeholder={orderAddress.state}
                        />
                    </Col>
                    <Col xs={6} >
                        <Form.Label>
                            <strong>Método de pago</strong>
                        </Form.Label>
                        <Form.Control
                            type="text"
                            onChange={() => { }}
                            value={order.payment_method}
                            readOnly={true}
                            placeholder={order.payment_method}
                        />
                    </Col>
                </Row>
            </Col>
        </Form>
    )
}
